import React from 'react'
import { useNavigate } from 'react-router-dom'

export default function DeniedPage() {
    const navigate = useNavigate()

    const handleLogout = () => {
        // Effacer les données de session/token
        localStorage.clear()
        sessionStorage.clear()

        // Rediriger vers la page d'accueil ou de login
        navigate('/', { replace: true })

        // Optionnel: recharger la page pour effacer complètement l'état
        // window.location.reload()
    }

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="max-w-md w-full space-y-8 p-10 bg-white rounded-xl shadow-lg text-center">
                <div className="mb-6">
                    <svg
                        className="mx-auto h-16 w-16 text-red-500"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                        />
                    </svg>
                </div>

                <h2 className="text-3xl font-bold text-gray-900 mb-4">
                    Accès Refusé
                </h2>

                <p className="text-gray-600 mb-8">
                    Vous n'avez pas les permissions nécessaires pour accéder à cette page.
                </p>

                <button
                    onClick={handleLogout}
                    className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors duration-200"
                >
                    Se déconnecter
                </button>

                <p className="mt-4 text-sm text-gray-500">
                    Vous serez redirigé vers la page d'accueil
                </p>
            </div>
        </div>
    )
}